import {
 ScrollArea
} from 'shared/components/ui/scroll-area';
import {
 Input
} from 'shared/components/ui/input';
import {
 Button
} from 'shared/components/ui/button';
import {
 Card, CardContent
} from 'shared/components/ui/card';
import {
 Settings, PlusCircle
} from 'lucide-react';
import Header from './Header';
import {
 JSX
} from 'react';
import {
 Item
} from '../types/storyBuilder.types';

interface SidebarProps {
  activeBuilder: 'opcode' | 'page';
  setActiveBuilder: (builder: 'opcode' | 'page') => void;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  filteredItems: Item[];
  setSelectedItem: (item: Item) => void;
  handleEditPage: (item: Item) => void;
  handleAddOpCode: () => void;
  handleAddPage: () => void;
  selectedItem: Item | null;
}

export default function Sidebar({
  activeBuilder,
  setActiveBuilder,
  searchTerm,
  setSearchTerm,
  filteredItems,
  setSelectedItem,
  handleEditPage,
  handleAddOpCode,
  handleAddPage,
  selectedItem,
}: SidebarProps): JSX.Element {
  return (
      <div className="w-64 border-r bg-card text-card-foreground flex flex-col">
          <Header activeBuilder={activeBuilder} setActiveBuilder={setActiveBuilder} />
          <div className="p-4">
              <Input
          placeholder={`Search ${activeBuilder === 'opcode' ? 'opcodes' : 'pages'}...`}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
          </div>
          <ScrollArea className="flex-1">
              <div className="p-4 space-y-2">
                  {filteredItems.map((item) => (
                      <Card
              key={item.id}
              className={`cursor-pointer ${selectedItem?.id === item.id ? 'border-primary' : ''}`}
              onClick={() => setSelectedItem(item)}
            >
                          <CardContent className="p-3 flex justify-between items-center">
                              <span className="text-card-foreground">{'name' in item ? item.name : item.title}</span>
                              <div className="flex items-center space-x-2">
                                  {activeBuilder === 'page' && (
                                  <Button
                      variant="ghost"
                      size="icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEditPage(item);
                      }}
                    >
                                      <Settings className="h-4 w-4" />
                                  </Button>
                  )}
                              </div>
                          </CardContent>
                      </Card>
          ))}
              </div>
          </ScrollArea>
          <div className="p-4 border-t">
              <Button
          onClick={activeBuilder === 'opcode' ? handleAddOpCode : handleAddPage}
          className="w-full bg-burgundy text-burgundy-foreground hover:bg-burgundy/90"
        >
                  <PlusCircle className="h-4 w-4 mr-2" />
                  New {activeBuilder === 'opcode' ? 'OpCode' : 'Page'}
              </Button>
          </div>
      </div>
  );
}
